import { StandardEvents } from '@shopify/events';

// Delegated handlers continue to work after Shopify's theme editor reloads a section.
document.addEventListener('toggle', (event) => {
  const disclosure = event.target;
  if (!(disclosure instanceof HTMLDetailsElement) || !disclosure.matches('[data-rv-disclosure]') || !disclosure.open) return;
  document.querySelectorAll('[data-rv-disclosure][open]').forEach((other) => {
    if (other !== disclosure) other.open = false;
  });
  if (disclosure.classList.contains('rv-search')) disclosure.querySelector('input[type="search"]')?.focus();
}, true);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-rv-disclosure][open]').forEach((disclosure) => {
    if (disclosure.contains(document.activeElement)) disclosure.querySelector('summary')?.focus();
    disclosure.open = false;
  });
});

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  document.querySelectorAll('[data-rv-disclosure][open]').forEach((disclosure) => {
    if (!disclosure.contains(event.target) || event.target.closest('.rv-mobile-nav__panel a')) disclosure.open = false;
  });
});

document.addEventListener('focusin', (event) => {
  if (!(event.target instanceof Element)) return;
  document.querySelectorAll('[data-rv-disclosure][open]').forEach((disclosure) => {
    if (!disclosure.contains(event.target)) disclosure.open = false;
  });
});

// Horizon updates the cart asynchronously; keep the custom header in the same lifecycle.
let countRevision = 0;
async function refreshCartCount(sections = {}) {
  const revision = ++countRevision;
  const link = document.querySelector('[data-rv-cart-link]');
  if (!link) return;
  let label;
  for (const html of Object.values(sections || {})) {
    if (!html?.includes('data-rv-cart-count-label')) continue;
    label = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rv-cart-count-label]')?.textContent.trim();
    if (label) break;
  }
  if (!label) {
    const url = new URL(link.href);
    url.searchParams.set('section_id', link.dataset.sectionId);
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) return;
    label = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-rv-cart-link]')?.title;
  }
  if (!label || revision !== countRevision) return;
  link.title = label;
  link.setAttribute('aria-label', 'Warenkorb, ' + label);
  link.querySelector('[data-rv-cart-count]').textContent = label.split(' ')[0];
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ detail }) => refreshCartCount(detail?.sections)).catch(() => {});
});
window.addEventListener('pageshow', (event) => {
  if (event.persisted) refreshCartCount().catch(() => {});
});
